import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { getCandidate, getFeedbackPDF, syncTeamsData, getCandidateAttachmentById } from '../../service/api';
import { baseURL } from '../../service/http';

import { toast } from "react-toastify";

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];

const isImageAttachment = (fileName) => {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  return IMAGE_EXTENSIONS.includes(ext);
};

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

const mapScoreLabelToNum = (label) => {
  if (!label) return 70;
  const l = label.toString().toLowerCase();
  if (l.includes('high') || l.includes('excellent') || l.includes('expert') || l.includes('very')) return 90;
  if (l.includes('good') || l.includes('decent') || l.includes('confident') || l.includes('decisive') || l.includes('answerable')) return 75;
  if (l.includes('moderate') || l.includes('average') || l.includes('passable') || l.includes('satisfactory')) return 60;
  if (l.includes('low') || l.includes('poor') || l.includes('mild') || l.includes('weak')) return 40;
  return 65; // default fallback
};

const getGaugeChartHTML = (title, summaryScore, traitsObj, colorHex) => {
  const traits = Object.entries(traitsObj || {}).map(([k, v]) => v).slice(0, 4); // max 4 rows

  const size = 160;
  const r = 65;
  const center = size / 2;
  const strokeWidth = 20;
  const C = 2 * Math.PI * r;
  const halfC = Math.PI * r;
  const score = summaryScore || 0;
  const dashArray = (score / 100) * halfC;

  let traitsHtml = '';
  traits.forEach((trait) => {
    const traitScore = trait.score || mapScoreLabelToNum(trait.scoreLabel);
    traitsHtml += `
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; font-size: 16px; color: #1e293b;">
                <div style="width: 45%; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 8px;">${trait.label}</div>
                <div style="flex-grow: 1; height: 8px; background: #e2e8f0; border-radius: 4px; overflow: hidden;">
                    <div style="height: 100%; width: ${traitScore}%; background: ${colorHex}; border-radius: 4px;"></div>
                </div>
                <div style="width: 15%; text-align: right; font-weight: 600; color: #64748b;">${traitScore}%</div>
            </div>
        `;
  });

  return `
        <div style="flex: 1; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; page-break-inside: avoid; min-width: 250px;">
           <div style="background: ${colorHex}; color: white; padding: 10px; font-weight: 600; text-align: center; font-size: 16px;">
              ${title}
           </div>
           <div style="padding: 16px; display: flex; flex-direction: column; align-items: center;">
               <!-- Gauge -->
               <div style="position: relative; width: ${size}px; height: ${size / 2}px; overflow: hidden; margin-bottom: 20px;">
                   <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
                       <circle cx="${center}" cy="${center}" r="${r}" fill="none" stroke="#e2e8f0" stroke-width="${strokeWidth}" stroke-dasharray="${halfC} ${C}" transform="rotate(180 ${center} ${center})" />
                       <circle cx="${center}" cy="${center}" r="${r}" fill="none" stroke="${colorHex}" stroke-width="${strokeWidth}" stroke-dasharray="${dashArray} ${C}" transform="rotate(180 ${center} ${center})" />
                   </svg>
                   <div style="position: absolute; bottom: 0; left: 0; right: 0; text-align: center; font-size: 28px; font-weight: 700; color: #1e293b; line-height: 1;">
                       ${score}
                   </div>
               </div>
               
               <!-- Linear Bars -->
               <!-- <div style="width: 100%;">
                   ${traitsHtml}
               </div> -->
           </div>
        </div>
    `;
};

const GaugeChartComp = ({ title, summaryScore, traitsObj, colorHex }) => {
  const traits = Object.entries(traitsObj || {}).map(([k, v]) => v).slice(0, 4);

  const size = 160;
  const r = 65;
  const center = size / 2;
  const strokeWidth = 20;
  const C = 2 * Math.PI * r;
  const halfC = Math.PI * r;
  const score = summaryScore || 0;
  const dashArray = (score / 100) * halfC;

  return (
    <div style={{ flex: 1, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden", minWidth: "250px" }}>
      <div style={{ background: colorHex, color: "white", padding: "10px", fontWeight: "600", textAlign: "center", fontSize: "16px" }}>
        {title}
      </div>
      <div style={{ padding: "16px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ position: "relative", width: size, height: size / 2, overflow: "hidden", marginBottom: "20px" }}>
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <circle cx={center} cy={center} r={r} fill="none" stroke="#e2e8f0" strokeWidth={strokeWidth} strokeDasharray={`${halfC} ${C}`} transform={`rotate(180 ${center} ${center})`} />
            <circle cx={center} cy={center} r={r} fill="none" stroke={colorHex} strokeWidth={strokeWidth} strokeDasharray={`${dashArray} ${C}`} transform={`rotate(180 ${center} ${center})`} />
          </svg>
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, textAlign: "center", fontSize: "28px", fontWeight: "700", color: "#1e293b", lineHeight: 1 }}>
            {score}
          </div>
        </div>

        {/* <div style={{ width: "100%" }}>
          {traits.map((trait, index) => {
            const traitScore = trait.score || mapScoreLabelToNum(trait.scoreLabel);
            return (
              <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", fontSize: "12px", color: "#1e293b" }}>
                <div style={{ width: "45%", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: "8px" }}>{trait.label}</div>
                <div style={{ flexGrow: 1, height: "8px", background: "#e2e8f0", borderRadius: "4px", overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${traitScore}%`, background: colorHex, borderRadius: "4px" }}></div>
                </div>
                <div style={{ width: "15%", textAlign: "right", fontWeight: "600", color: "#64748b" }}>{traitScore}%</div>
              </div>
            );
          })}
        </div> */}
      </div>
    </div>
  );
};

const CustomRating = ({ value, readOnly = true }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span
        key={i}
        style={{
          color: i <= value ? "#3b71ca" : "#e2e8f0",
          fontSize: "20px",
          marginRight: "2px"
        }}
      >
        ★
      </span>
    );
  }
  return <div style={{ display: "flex", alignItems: "center" }}>{stars}</div>;
};

const generatePDF = async (candidateData, type) => {
  const printWindow = window.open('', '_blank');

  const htmlContent = `
      <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8">
              <title>Feedback Report - ${candidateData.candidateName}</title>
              <style>
                * {
                  margin: 0;
                padding: 0;
                box-sizing: border-box;
            }

                @page {
                  margin: 0;
                size: A4;
            }

                body {
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                color: #334155;
                line-height: 1.4;
                background: white;
                padding: 8px;
                font-size: 16px;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
            }

                .container {
                  margin: 0 auto;
                background: white;
                border-radius: 12px;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

                .header {
                  color: black;
                padding: 12px 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 16px;
            }

                .logo-section {
                  flex: 0 0 auto;
            }

                .logo-fallback {
                  font-size: 18px;
                font-weight: 700;
                color: white;
            }

                .candidate-info {
                  flex: 1;
                text-align: center;
            }

                .report-title {
                  font-size: 16px;
                font-weight: 600;
                margin-bottom: 2px;
                opacity: 0.9;
            }

                .candidate-name {
                  font-size: 20px;
                font-weight: 700;
                margin-bottom: 4px;
                letter-spacing: -0.3px;
            }

                .job-info {
                  font-size: 16px;
                opacity: 0.9;
                margin: 4px 0;
            }

                .job-id {
                  font-size: 14px;
                opacity: 0.8;
                background: rgba(255, 255, 255, 0.2);
                padding: 3px 10px;
                border-radius: 15px;
                display: inline-block;
                margin-top: 4px;
            }

                .contact-info {
                  flex: 0 0 auto;
                text-align: right;
                font-size: 16px;
                opacity: 0.9;
                line-height: 1.4;
            }

                .content {
                  padding: 16px 20px;
            }

                .status-badge {
                  display: inline-flex;
                align-items: center;
                gap: 6px;
                background: linear-gradient(135deg, #10b981, #059669);
                color: white;
                padding: 2px 16px;
                border-radius: 25px;
                font-weight: 600;
                font-size: 16px;
                margin: 2px 0 12px 0;
            }

                .status-badge.rejected {
                  background: linear-gradient(135deg, #ef4444, #dc2626);
            }

                .section-title {
                  font-size: 20px;
                font-weight: 600;
                color: #3b71ca;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                gap: 8px;
                page-break-after: avoid;
            }

                .section-title::before {
                  content: '';
                width: 3px;
                height: 20px;
                background: linear-gradient(135deg, #3b71ca, #2563eb);
                border-radius: 2px;
            }

                .summary-box {
                  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
                padding: 16px;
                border-radius: 12px;
                border: 1px solid #e2e8f0;
                margin: 16px 0 24px 0;
                font-size: 16px;
                line-height: 1.5;
            }

                /* Block layout for skills */
                .skills-grid {
                  display: flex;
                flex-direction: column;
                gap: 12px;
                margin: 16px 0 24px 0;
            }

                .skill-card {
                  background: white;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                padding: 12px;
                position: relative;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
                page-break-inside: avoid;
                min-height: 140px;
            }

                .skill-card::before {
                  content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(90deg, #3b71ca, #2563eb);
            }

                .skill-header {
                  display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: 10px;
                gap: 8px;
            }

                .skill-name {
                  font-size: 16px;
                font-weight: 600;
                color: #1e293b;
                line-height: 1.3;
                flex: 1;
            }

                .rating {
                  display: flex;
                gap: 1px;
                flex-shrink: 0;
            }

                .star {
                  color: #3b71ca;
                font-size: 16px;
            }

                .star.empty {
                  color: #e2e8f0;
            }

                .proficiency-grid {
                  display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 8px;
                margin-bottom: 10px;
            }

                .proficiency-item {
                  background: #f8fafc;
                padding: 6px 8px;
                border-radius: 6px;
            }

                .proficiency-label {
                  font-size: 14px;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                margin-bottom: 2px;
            }

                .proficiency-value {
                  font-size: 16px;
                font-weight: 600;
                color: #334155;
            }

                .skill-comments {
                  color: #64748b;
                font-size: 16px;
                line-height: 1.4;
                word-wrap: break-word;
                overflow-wrap: break-word;
            }

                /* Block layout for competencies */
                .competency-grid {
                  display: flex;
                flex-direction: column;
                gap: 12px;
                margin: 16px 0 24px 0;
            }

                .competency-item {
                  background: white;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                padding: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
                page-break-inside: avoid;
                min-height: 100px;
            }

                .competency-title {
                  font-size: 16px;
                font-weight: 600;
                color: #1e293b;
                margin-bottom: 8px;
                line-height: 1.3;
            }

                .competency-rating {
                  display: flex;
                gap: 1px;
                margin-bottom: 8px;
            }

                .competency-comments {
                  font-size: 16px;
                color: #64748b;
                line-height: 1.4;
                word-wrap: break-word;
                overflow-wrap: break-word;
            }

                .footer {
                  background: #f8fafc;
                padding: 12px 20px;
                border-top: 1px solid #e2e8f0;
                text-align: center;
                color: #64748b;
                font-size: 14px;
            }

                /* Print optimizations */
                @media print {
                  body {
                  margin: 0;
                padding: 5px;
                font-size: 14px;
                }
                .container {
                  box-shadow: none;
                border: 1px solid #e2e8f0;
                }
                .no-print {display: none !important; }
                .header {page-break-after: avoid; }
                .section-title {page-break-after: avoid; }

                /* Allow grids to break across pages but keep individual cards together */
                .skills-grid {
                  display: flex !important;
                flex-direction: column !important;
                page-break-inside: auto !important;
                }
                .competency-grid {
                  display: flex !important;
                flex-direction: column !important;
                page-break-inside: auto !important;
                }
                .skill-card {
                  page-break-inside: avoid !important;
                break-inside: avoid !important;
                }
                .competency-item {
                  page-break-inside: avoid !important;
                break-inside: avoid !important;
                }

                /* Keep section title with first card */
                .section-title {
                  page-break-after: avoid !important;
                break-after: avoid !important;
                }

                /* Page breaks */
                .page-break {
                  page-break-before: always;
                }

                .avoid-break {
                  page-break-inside: avoid;
                break-inside: avoid;
                }
            }

                /* Responsive fallback for smaller screens */
                @media (max-width: 1000px) {
                }

                @media (max-width: 600px) {
                .header {
                  flex-direction: column;
                text-align: center;
                gap: 12px;
                }
                .contact-info {
                  text-align: center;
                }
            }
              </style>
          </head>
          <body>
            <div class="container">
              <!-- Header -->
              <div class="header">
                <div class="logo-section">
                  ${candidateData.customerLogo ?
      `<img src="${baseURL}/user/logo/${candidateData.customerLogo}" style="width: 200px; height: auto; object-fit: contain;" alt="Logo" />`
      : `<img src="${window.location.origin}/Images/panls-logo-white.png" style="width: 200px; height: auto;" alt="PANLS Logo" />
         <div class="logo-fallback" style="display: none; font-size: 16px; font-weight: 700; color: #3b71ca;">PANLS.AI</div>`
    }
                </div>
                <div class="candidate-info">
                  <div class="report-title">Evaluation and Analysis Report</div>
                  <div class="candidate-name">${candidateData.candidateName}</div>
                  <div class="job-info">${candidateData.jobName} (${candidateData.currentCountry})</div>
                  <span class="job-id">${candidateData.candidateId}</span>
                </div>
                <div class="contact-info">
                  <div>${candidateData.candidateEmailId}</div>
                  <div>${candidateData.contactNumber}</div>
                </div>
              </div>

              <div class="content">
                <!-- Status Badge -->
                <div class="status-badge ${candidateData.overallFeedback?.toLowerCase() === 'rejected' ? 'rejected' : ''}">
                  <span>${candidateData.overallFeedback?.toLowerCase() === 'rejected' ? '✗' : '✓'}</span>
                  ${candidateData.overallFeedback?.toUpperCase() || 'EVALUATED'}
                </div>

                <!-- Overall Assessment -->
                <div class="avoid-break" style="margin-bottom: 24px;">
                  <h2 class="section-title">Overall Assessment</h2>
                  <div class="summary-box">
                    <p>${candidateData.recommendations || 'No recommendations available'}</p>
                  </div>
                </div>

                <!-- Technical Skills -->
                ${candidateData.dynamicSkills ? `
                <div style="margin-bottom: 24px;">
                    <h2 class="section-title">Technical Skills Assessment</h2>
                    <div class="skills-grid">
                        ${candidateData.dynamicSkills.map(skill => `
                            <div class="skill-card" style="page-break-inside: avoid; break-inside: avoid;">
                                <div class="skill-header">
                                    <span class="skill-name">${skill.skillTopic}</span>
                                    <div class="rating">
                                        ${[1, 2, 3, 4, 5].map(i => `<span class="star ${i <= skill.rating ? '' : 'empty'}">★</span>`).join('')}
                                    </div>
                                </div>
                                <div class="proficiency-grid">
                                    <div class="proficiency-item">
                                        <div class="proficiency-label">Expected</div>
                                        <div class="proficiency-value">${skill.expectedProficiency}</div>
                                    </div>
                                    <div class="proficiency-item">
                                        <div class="proficiency-label">Possess</div>
                                        <div class="proficiency-value">${skill.possessProficiency}</div>
                                    </div>
                                </div>
                                <div class="skill-comments">${skill.comments}</div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                ` : ''}

                <!-- Core Competencies -->
                ${candidateData.standardSkills && type === 'full' ? `
                <div style="margin-bottom: 24px;">
                    <h2 class="section-title">Core Competencies</h2>
                    <div class="competency-grid">
                        ${candidateData.standardSkills.map(competency => `
                            <div class="competency-item" style="page-break-inside: avoid; break-inside: avoid;">
                                <div class="competency-title">${competency.skillTopic}</div>
                                <div class="competency-rating">
                                    ${[1, 2, 3, 4, 5].map(i => `<span class="star ${i <= competency.rating ? '' : 'empty'}">★</span>`).join('')}
                                </div>
                                <div class="competency-comments">
                                    ${competency.comments}
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                ` : ''}
              </div>

              ${`
            <div class="content">
              
                <h2 class="section-title">Interview Recording & AI Summary</h2>
                <div class="summary-box">
                    ${candidateData.recordedVideoUrl ? `<p><strong>Recording:</strong> Access the interview recording <a href="${candidateData.recordedVideoUrl}" target="_blank" rel="noopener noreferrer">here</a>.</p>` : ''}
                    ${candidateData.teamsSummary ? `<p style="margin-top: 10px;"><strong>AI Summary:</strong></p><p>${candidateData.teamsSummary.replace(/\n/g, '<br/>')}</p>` : ''}
                    ${!candidateData.recordedVideoUrl && !candidateData.teamsSummary ? '<p>No recording or summary available yet.</p>' : ''}
                </div>
                
            </div>
            ` }

              ${(() => {
      const aiReport = candidateData.aiFeedback?.runs?.find(run => run.runId === candidateData.aiFeedback.latestRunId)?.result;
      if (!aiReport) return '';

      return `
            <div class="page-break"></div>
            <div class="content">
                <h2 class="section-title">AI-Powered Feedback Report</h2>
                
                <!-- Overall Score -->
                ${aiReport.overallScore ? `
                <div style="background: linear-gradient(135deg, #3b71ca 0%, #2563eb 100%); color: white; padding: 20px; border-radius: 12px; margin-bottom: 20px; text-align: center;">
                    <div style="font-size: 16px; opacity: 0.9; margin-bottom: 6px;">Overall AI Score</div>
                    <div style="font-size: 36px; font-weight: 700;">${aiReport.overallScore}/100</div>
                </div>
                ` : ''}

                <!-- Resume Summary -->
                ${aiReport.resumeSummary?.length > 0 ? `
                <div style="margin-bottom: 20px;">
                    <h3 style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">Resume Summary</h3>
                    <div style="background: white; border: 1px solid #e2e8f0; border-radius: 10px; padding: 16px;">
                        <ul style="margin: 0; padding-left: 18px; color: #334155; font-size: 16px; line-height: 1.6;">
                            ${aiReport.resumeSummary.map(item => `<li style="margin-bottom: 6px;">${item}</li>`).join('')}
                        </ul>
                    </div>
                </div>
                ` : ''}

                <!-- Strengths & Weaknesses -->
                <div style="display: flex; flex-direction: column; gap: 16px; margin-bottom: 20px;">
                    ${aiReport.strengths?.length > 0 ? `
                    <div>
                        <h3 style="font-size: 18px; font-weight: 600; color: #16a34a; margin-bottom: 10px;">✓ Strengths</h3>
                        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 14px;">
                            <ul style="margin: 0; padding-left: 18px; color: #166534; font-size: 16px; line-height: 1.5;">
                                ${aiReport.strengths.map(item => `<li style="margin-bottom: 6px;">${item}</li>`).join('')}
                            </ul>
                        </div>
                    </div>
                    ` : ''}
                    
                    ${aiReport.weaknesses?.length > 0 ? `
                    <div>
                        <h3 style="font-size: 18px; font-weight: 600; color: #dc2626; margin-bottom: 10px;">⚠ Areas for Improvement</h3>
                        <div style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 14px;">
                            <ul style="margin: 0; padding-left: 18px; color: #991b1b; font-size: 16px; line-height: 1.5;">
                                ${aiReport.weaknesses.map(item => `<li style="margin-bottom: 6px;">${item}</li>`).join('')}
                            </ul>
                        </div>
                    </div>
                    ` : ''}
                </div>

                <!-- Behavioral & Leadership Skills -->
                ${(aiReport.softSkills || aiReport.analyticalSkills || aiReport.leadershipSkills) ? `
                <div style="margin-bottom: 24px; page-break-inside: avoid;">
                    <div style="display: flex; gap: 20px; align-items: stretch; flex-wrap: wrap;">
                        ${aiReport.softSkills ? getGaugeChartHTML('Soft Skills (Score: ' + aiReport.softSkills.score + '/100)', aiReport.softSkills.score, aiReport.softSkills.traits, '#1e3a8a') : ''}
                        ${aiReport.analyticalSkills ? getGaugeChartHTML('Analytical Skills (Score: ' + aiReport.analyticalSkills.score + '/100)', aiReport.analyticalSkills.score, aiReport.analyticalSkills.traits, '#0d9488') : ''}
                        ${aiReport.leadershipSkills ? getGaugeChartHTML('Leadership Skills (Score: ' + aiReport.leadershipSkills.score + '/100)', aiReport.leadershipSkills.score, aiReport.leadershipSkills.traits, '#1e40af') : ''}
                    </div>
                </div>
                ` : ''}

                <!-- Mandatory Skills -->
                ${aiReport.mandatorySkills?.length > 0 ? `
                <div style="margin-bottom: 24px; page-break-inside: avoid;">
                    <h3 style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">Mandatory Skills (Score: ${aiReport.mandatorySkillsScore || 0}/100)</h3>
                    <div style="display: flex; gap: 20px; align-items: stretch; flex-wrap: wrap;">
                        ${aiReport.mandatorySkills.map(skill => getGaugeChartHTML(skill.skill || skill.skillTopic, skill.score, {}, '#0369a1')).join('')}
                    </div>
                </div>
                ` : ''}

                <!-- Optional Skills -->
                ${aiReport.optionalSkills?.length > 0 ? `
                <div style="margin-bottom: 24px; page-break-inside: avoid;">
                    <h3 style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">Optional Skills (Score: ${aiReport.optionalSkillsScore || 0}/100)</h3>
                    <div style="display: flex; gap: 20px; align-items: stretch; flex-wrap: wrap;">
                        ${aiReport.optionalSkills.map(skill => getGaugeChartHTML(skill.skill || skill.skillTopic, skill.score, {}, '#8b5cf6')).join('')}
                    </div>
                </div>
                ` : ''}

                <!-- AI Conclusion -->
                ${aiReport.conclusion ? `
                <div style="margin-bottom: 20px; page-break-inside: avoid;">
                    <h3 style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">AI Conclusion</h3>
                    <div style="background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); padding: 16px; border-radius: 10px; border: 1px solid #e2e8f0;">
                        <p style="font-size: 16px; line-height: 1.5; color: #334155; margin: 0;">${aiReport.conclusion}</p>
                    </div>
                </div>
                ` : ''}

                <!-- Interview Q&A Analysis -->
                ${aiReport.questions?.length > 0 ? `
                <div style="margin-bottom: 20px;">
                    <h3 style="font-size: 18px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">Interview Q&A Analysis</h3>
                    ${aiReport.questions.slice(0, 5).map((qa, idx) => `
                    <div style="background: white; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px; margin-bottom: 12px; position: relative; page-break-inside: avoid;">
                        <div style="position: absolute; top: 12px; right: 12px; background: ${qa.accuracyPercent >= 70 ? '#dcfce7' : qa.accuracyPercent >= 40 ? '#fef3c7' : '#fee2e2'}; color: ${qa.accuracyPercent >= 70 ? '#166534' : qa.accuracyPercent >= 40 ? '#92400e' : '#991b1b'}; padding: 4px 10px; border-radius: 15px; font-size: 14px; font-weight: 600;">
                            ${qa.accuracyPercent}% Accurate
                        </div>
                        <div style="margin-bottom: 10px; padding-right: 90px;">
                            <div style="font-size: 12px; color: #64748b; margin-bottom: 3px; font-weight: 600;">QUESTION ${idx + 1}</div>
                            <div style="font-size: 16px; color: #1e293b; font-weight: 500; line-height: 1.4;">${qa.question}</div>
                        </div>
                        <div style="margin-bottom: 10px;">
                            <div style="font-size: 12px; color: #64748b; margin-bottom: 3px; font-weight: 600;">ANSWER</div>
                            <div style="font-size: 14px; color: #475569; line-height: 1.4; background: #f8fafc; padding: 10px; border-radius: 6px; max-height: 100px; overflow: hidden;">${qa.answer.substring(0, 300)}${qa.answer.length > 300 ? '...' : ''}</div>
                        </div>
                        ${qa.feedbacks?.length > 0 ? `
                        <div>
                            <div style="font-size: 12px; color: #64748b; margin-bottom: 6px; font-weight: 600;">AI FEEDBACK</div>
                            <ul style="margin: 0; padding-left: 16px; font-size: 14px; color: #334155; line-height: 1.5;">
                                ${qa.feedbacks.slice(0, 2).map(feedback => `<li style="margin-bottom: 4px;">${feedback}</li>`).join('')}
                            </ul>
                        </div>
                        ` : ''}
                    </div>
                    `).join('')}
                </div>
                ` : ''}
            </div>
            `;
    })()}

              ${(candidateData.attachmentImages && candidateData.attachmentImages.length > 0) ? `
            <div class="page-break"></div>
            <div class="content">
                <h2 class="section-title">Additional Attachments</h2>
                <div style="display: flex; flex-direction: column; gap: 20px;">
                    ${candidateData.attachmentImages.map(att => att.isImage ? `
                    <div style="page-break-inside: avoid; break-inside: avoid; border: 1px solid #e2e8f0; border-radius: 10px; padding: 16px; background: white;">
                        <div style="font-size: 16px; font-weight: 600; color: #1e293b; margin-bottom: 10px;">${att.name}</div>
                        <img src="${att.dataUrl}" alt="${att.name}" style="max-width: 100%; height: auto; border-radius: 8px;" />
                    </div>
                    ` : `
                    <div style="page-break-inside: avoid; break-inside: avoid; border: 1px solid #e2e8f0; border-radius: 10px; padding: 16px; background: white;">
                        <div style="font-size: 16px; font-weight: 600; color: #1e293b; margin-bottom: 4px;">${att.name}</div>
                        <div style="font-size: 14px; color: #64748b;">${att.fileName}</div>
                    </div>
                    `).join('')}
                </div>
            </div>
            ` : ''}

              <!-- Footer -->
              <div class="footer">
                <p>© 2024 PANLS.AI Pvt Ltd. All Rights Reserved.</p>
                <p style="margin-top: 2px; font-size: 12px;">
                  Evaluation Report Generated on ${new Date().toLocaleDateString()}
                </p>
              </div>
            </div>

            <script>
            // Auto-trigger print dialog
              window.onload = function() {
                // Wait for styles to load
                setTimeout(() => {
                  window.print();
                  // Close after printing or user cancels
                  setTimeout(() => {
                    window.close();
                  }, 1000);
                }, 500);
            };

              // Handle print events
              window.addEventListener('beforeprint', function() {
                document.body.style.fontSize = '14px';
            });

              window.addEventListener('afterprint', function() {
                setTimeout(() => {
                  window.close();
                }, 500);
            });
            </script>
          </body>
        </html>
    `;


  printWindow.document.write(htmlContent);
  printWindow.document.close();
};

export default function FeedbackPDF() {

  const { candidateId } = useParams();
  const [candidateObj, setCandidateData] = useState({});
  const [attachmentImages, setAttachmentImages] = useState([]);
  const htmlRef = useRef(null);

  const loadAttachments = async (attachments) => {
    if (!attachments || attachments.length === 0) {
      setAttachmentImages([]);
      return;
    }
    const results = [];
    for (const att of attachments) {
      try {
        const blob = await getCandidateAttachmentById(att.documentId);
        const dataUrl = await blobToDataUrl(blob);
        results.push({
          name: att.documentName,
          fileName: att.documentId,
          dataUrl,
          isImage: isImageAttachment(att.documentId)
        });
      } catch (err) {
        console.error('Failed to load attachment', att, err);
      }
    }
    setAttachmentImages(results);
  };

  useEffect(() => {
    getCandidate(candidateId).then((res) => {
      console.log(res.data)
      if (res.data) {
        setCandidateData(res.data);
        loadAttachments(res.data.attachments);

        // Try to sync Teams data if missing
        if (res.data.teamsMeetingId && (!res.data.teamsSummary || !res.data.teamsRecordingUrl)) {
          syncTeamsData(candidateId).then(syncRes => {
            if (syncRes.data) {
              setCandidateData(syncRes.data);
              toast.success("Teams data synced successfully");
            }
          }).catch(err => console.error("Auto-sync failed", err));
        }
      }
    });
  }, [candidateId, candidateObj?.teamsMeetingId]);

  const aiReport = candidateObj.aiFeedback?.runs?.find(run => run.runId === candidateObj.aiFeedback.latestRunId)?.result;

  return (
    <>
      <div
        className="container"
        style={{
          background: "#F6F6F6 0% 0% no-repeat padding-box",
          borderRadius: "4px",
          opacity: "1",
          marginTop: "8px",
          marginBottom: "8px",
        }}
      >
        <div className="row">
          <div className="col">
            <button
              className="btn btn-primary"
              onClick={async (e) => {
                e.preventDefault(true)
                try {
                  await generatePDF({ ...candidateObj, attachmentImages }, 'full');
                } catch (error) {
                  toast.error('Unable to download Feedback PDF..!' + error)
                }
              }}
            >
              <i className="fa fa-download"></i>{"  "}Full Download
            </button>
          </div>
          <div className="col" style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                if (htmlRef.current) {
                  const htmlContent = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Feedback Report - ${candidateObj?.candidateName || 'Candidate'}</title>
</head>
<body style="margin: 0; padding: 0; box-sizing: border-box; background: white;">
${htmlRef.current.outerHTML}
</body>
</html>`;
                  const blob = new Blob([htmlContent], { type: 'text/html' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `${candidateObj?.candidateName || 'Feedback'}.html`;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                }
              }}
            >
              <i className="fa fa-download"></i>{"  "} Download HTML
            </button>
          </div>
        </div>
      </div>
      <div
        ref={htmlRef}
        style={{
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          background: "linear-gradient(135deg, #fff 0%, #fff 100%)",
          color: "white",
          lineHeight: "1.6",
          padding: "20px",
          minHeight: "100vh"
        }}>
        <div style={{
          margin: "0 auto",
          background: "white",
          overflow: "hidden"
        }}>
          <div style={{
            color: "black",
            padding: "20px",
            position: "relative"
          }}>
            <div style={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "40px"
            }}>
              {/* Logo Section */}
              <div style={{
                flex: "0 0 auto"
              }}>
                {candidateObj.customerLogo ? (
                  <img
                    style={{ width: '200px', height: 'auto', objectFit: 'contain' }}
                    src={`${baseURL}/user/logo/${candidateObj.customerLogo}`}
                    alt="Customer Logo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      // Try to show fallback if sibling exists, or just hide
                    }}
                  />
                ) : (
                  <>
                    <img
                      style={{ width: '200px', height: 'auto' }}
                      src={`${window.location.origin}/Images/panls-logo-white.png`}
                      alt="PANLS Logo"
                    />
                    <div style={{
                      display: 'none',
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#3b71ca'
                    }}>
                      PANLS.AI
                    </div>
                  </>
                )}
              </div>

              {/* Candidate Info Section */}
              <div style={{
                flex: "1",
                textAlign: "center"
              }}>
                <h4 style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  margin: "0 0 16px 0",
                  opacity: "0.9"
                }}>
                  Evaluation and Analysis Report
                </h4>
                <h1 style={{
                  fontSize: "36px",
                  fontWeight: "700",
                  marginBottom: "8px",
                  letterSpacing: "-0.5px",
                  margin: "0 0 8px 0"
                }}>
                  {candidateObj.candidateName || "Loading..."}
                </h1>
                <p style={{
                  fontSize: "20px",
                  opacity: "0.9",
                  margin: "8px 0 4px 0"
                }}>
                  {candidateObj.jobName} ({candidateObj.currentCountry})
                </p>
                <span style={{
                  fontSize: "16px",
                  opacity: "0.8",
                  background: "rgba(255, 255, 255, 0.2)",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  display: "inline-block",
                  marginTop: "8px"
                }}>
                  {candidateObj.candidateId}
                </span>
              </div>

              {/* Contact Info Section */}
              <div style={{
                flex: "0 0 auto",
                textAlign: "right",
                fontSize: "18px",
                opacity: "0.9",
                lineHeight: "1.6"
              }}>
                <div>{candidateObj.candidateEmailId}</div>
                <div>{candidateObj.contactNumber}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Status Badge */}
        {candidateObj.overallFeedback && (
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: candidateObj.overallFeedback.toLowerCase() === 'selected'
              ? "linear-gradient(135deg, #10b981, #059669)"
              : candidateObj.overallFeedback.toLowerCase() === 'rejected'
                ? "linear-gradient(135deg, #ef4444, #dc2626)"
                : "linear-gradient(135deg, #f59e0b, #d97706)",
            color: "white",
            padding: "12px 24px",
            borderRadius: "50px",
            fontWeight: "600",
            fontSize: "18px",
            margin: "20px 0"
          }}>
            <span style={{ fontSize: "20px" }}>
              {candidateObj.overallFeedback.toLowerCase() === 'selected' ? '✓' :
                candidateObj.overallFeedback.toLowerCase() === 'rejected' ? '✗' : '◐'}
            </span>
            {candidateObj.overallFeedback.toUpperCase()}
          </div>
        )}

        {/* Overall Assessment */}
        <div style={{ marginBottom: "40px" }}>
          <h2 style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#3b71ca",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "0 0 20px 0"
          }}>
            <div style={{
              width: "4px",
              height: "30px",
              background: "linear-gradient(135deg, #3b71ca, #2563eb)",
              borderRadius: "2px"
            }}></div>
            Overall Assessment
          </h2>
          {candidateObj.recommendations && (
            <div style={{
              background: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
              padding: "30px",
              borderRadius: "16px",
              border: "1px solid #e2e8f0"
            }}>
              <p style={{
                fontSize: "16px",
                lineHeight: "1.7",
                color: "#334155",
                margin: "0"
              }}>
                {candidateObj.recommendations}
              </p>
            </div>
          )}
        </div>
        {/* Technical Skills Assessment */}
        <div style={{ marginBottom: "40px" }}>
          <h2 style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#3b71ca",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "0 0 20px 0"
          }}>
            <div style={{
              width: "4px",
              height: "30px",
              background: "linear-gradient(135deg, #3b71ca, #2563eb)",
              borderRadius: "2px"
            }}></div>
            Technical Skills Assessment
          </h2>
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            margin: "24px 0"
          }}>
            {candidateObj?.dynamicSkills?.map((skill, index) => (
              <div key={index} style={{
                background: "white",
                border: "1px solid #e2e8f0",
                borderRadius: "16px",
                padding: "24px",
                position: "relative",
                overflow: "hidden",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
              }}>
                <div style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b71ca, #2563eb)"
                }}></div>

                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "16px"
                }}>
                  <span style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#1e293b"
                  }}>
                    {skill.skillTopic}
                  </span>
                  <CustomRating value={skill.rating} />
                </div>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px",
                  marginBottom: "16px"
                }}>
                  <div>
                    <div style={{
                      fontSize: "14px",
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      marginBottom: "4px"
                    }}>Expected Proficiency</div>
                    <div style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#334155",
                      background: "#f1f5f9",
                      padding: "4px 8px",
                      borderRadius: "6px"
                    }}>
                      {skill.expectedProficiency}
                    </div>
                  </div>
                  <div>
                    <div style={{
                      fontSize: "14px",
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      marginBottom: "4px"
                    }}>Possess Proficiency</div>
                    <div style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#334155",
                      background: "#f1f5f9",
                      padding: "4px 8px",
                      borderRadius: "6px"
                    }}>
                      {skill.possessProficiency}
                    </div>
                  </div>
                </div>

                <div style={{
                  color: "#64748b",
                  fontSize: "16px",
                  lineHeight: "1.6"
                }}>
                  {skill.comments}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Core Competencies */}
        {candidateObj?.standardSkills?.length > 0 && (
          <div style={{ marginBottom: "40px" }}>
            <h2 style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#3b71ca",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              margin: "0 0 20px 0"
            }}>
              <div style={{
                width: "4px",
                height: "30px",
                background: "linear-gradient(135deg, #3b71ca, #2563eb)",
                borderRadius: "2px"
              }}></div>
              Core Competencies
            </h2>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px"
            }}>
              {candidateObj.standardSkills.map((competency, index) => (
                <div key={index} style={{
                  background: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "20px",
                  transition: "all 0.2s ease",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
                }}>
                  <div style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#1e293b",
                    marginBottom: "12px"
                  }}>
                    {competency.skillTopic}
                  </div>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}>
                    <CustomRating value={competency.rating} />
                  </div>
                  <div style={{
                    color: "#64748b",
                    fontSize: "16px",
                    marginTop: "8px"
                  }}>
                    {competency.comments}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Recorded Meeting */}
        {/* Recorded Meeting & AI Summary */}
        {(candidateObj.recordedVideoUrl || candidateObj.teamsSummary) && (
          <div style={{ marginBottom: "40px" }}>
            <h2 style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#3b71ca",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              margin: "0 0 20px 0"
            }}>
              <div style={{
                width: "4px",
                height: "30px",
                background: "linear-gradient(135deg, #3b71ca, #2563eb)",
                borderRadius: "2px"
              }}></div>
              Interview Insights
            </h2>
            <div style={{
              background: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              padding: "30px",
            }}>
              <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>

                {/* Recording Card */}
                {candidateObj.recordedVideoUrl && (
                  <a
                    href={candidateObj.recordedVideoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      flex: "1",
                      minWidth: "250px",
                      textDecoration: "none",
                      color: "inherit"
                    }}
                  >
                    <div style={{
                      border: "1px solid #e2e8f0",
                      borderRadius: "12px",
                      padding: "24px",
                      textAlign: "center",
                      background: "#f8fafc",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-4px)";
                        e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.borderColor = "#3b71ca";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        background: "#eff6ff",
                        color: "#3b71ca",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        marginBottom: "16px"
                      }}>
                        <i className="fa fa-video-camera"></i>
                      </div>
                      <h3 style={{ fontSize: "20px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>Recorded Meeting</h3>
                      <p style={{ fontSize: "16px", color: "#64748b", margin: 0 }}>Click to watch the full interview recording</p>
                    </div>
                  </a>
                )}

                {/* AI Transcript Card */}
                {candidateObj.teamsTranscriptUrl && (
                  <a
                    href={candidateObj.teamsTranscriptUrl || candidateObj.recordedVideoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      flex: "1",
                      minWidth: "250px",
                      textDecoration: "none",
                      color: "inherit"
                    }}
                  >
                    <div style={{
                      border: "1px solid #e2e8f0",
                      borderRadius: "12px",
                      padding: "24px",
                      textAlign: "center",
                      background: "#f8fafc",
                      transition: "transform 0.2s, box-shadow 0.2s",
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-4px)";
                        e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.borderColor = "#3b71ca";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        background: "#f0fdf4",
                        color: "#16a34a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        marginBottom: "16px"
                      }}>
                        <i className="fa fa-file-text-o"></i>
                      </div>
                      <h3 style={{ fontSize: "20px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>AI Transcript</h3>
                      <p style={{ fontSize: "16px", color: "#64748b", margin: 0 }}>Click to view the interview transcript</p>
                    </div>
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {/* AI Feedback Report */}
        {aiReport && (
          <div style={{ marginBottom: "40px", pageBreakBefore: "always" }}>
            <h2 style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#3b71ca",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              margin: "0 0 20px 0"
            }}>
              <div style={{
                width: "4px",
                height: "30px",
                background: "linear-gradient(135deg, #3b71ca, #2563eb)",
                borderRadius: "2px"
              }}></div>
              AI-Powered Feedback Report
            </h2>

            {/* Overall Score */}
            {aiReport.overallScore && (
              <div style={{
                background: "linear-gradient(135deg, #3b71ca 0%, #2563eb 100%)",
                color: "white",
                padding: "24px",
                borderRadius: "16px",
                marginBottom: "24px",
                textAlign: "center"
              }}>
                <div style={{ fontSize: "16px", opacity: "0.9", marginBottom: "8px" }}>Overall AI Score</div>
                <div style={{ fontSize: "48px", fontWeight: "700" }}>{aiReport.overallScore}/100</div>
              </div>
            )}

            {/* Resume Summary */}
            {aiReport.resumeSummary?.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  marginBottom: "12px"
                }}>Resume Summary</h3>
                <div style={{
                  background: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "20px"
                }}>
                  <ul style={{ margin: 0, paddingLeft: "20px", color: "#334155", fontSize: "16px", lineHeight: "1.8" }}>
                    {aiReport.resumeSummary.map((item, idx) => (
                      <li key={idx} style={{ marginBottom: "8px" }}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Strengths & Weaknesses */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "24px" }}>
              {/* Strengths */}
              {aiReport.strengths?.length > 0 && (
                <div>
                  <h3 style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#16a34a",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span>✓</span> Strengths
                  </h3>
                  <div style={{
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    borderRadius: "12px",
                    padding: "20px"
                  }}>
                    <ul style={{ margin: 0, paddingLeft: "20px", color: "#166534", fontSize: "16px", lineHeight: "1.7" }}>
                      {aiReport.strengths.map((item, idx) => (
                        <li key={idx} style={{ marginBottom: "8px" }}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Weaknesses */}
              {aiReport.weaknesses?.length > 0 && (
                <div>
                  <h3 style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#dc2626",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span>⚠</span> Areas for Improvement
                  </h3>
                  <div style={{
                    background: "#fef2f2",
                    border: "1px solid #fecaca",
                    borderRadius: "12px",
                    padding: "20px"
                  }}>
                    <ul style={{ margin: 0, paddingLeft: "20px", color: "#991b1b", fontSize: "16px", lineHeight: "1.7" }}>
                      {aiReport.weaknesses.map((item, idx) => (
                        <li key={idx} style={{ marginBottom: "8px" }}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Behavioral & Leadership Skills */}
            {(aiReport.softSkills || aiReport.analyticalSkills || aiReport.leadershipSkills) && (
              <div style={{ marginBottom: "24px", display: "flex", gap: "20px", alignItems: "stretch", flexWrap: "wrap" }}>
                {aiReport.softSkills && <GaugeChartComp title={<>Soft Skills (Score: {aiReport.softSkills.score}/100)</>} summaryScore={aiReport.softSkills.score} traitsObj={aiReport.softSkills.traits} colorHex="#1e3a8a" />}
                {aiReport.analyticalSkills && <GaugeChartComp title={<>Analytical Skills (Score: {aiReport.analyticalSkills.score}/100)</>} summaryScore={aiReport.analyticalSkills.score} traitsObj={aiReport.analyticalSkills.traits} colorHex="#0d9488" />}
                {aiReport.leadershipSkills && <GaugeChartComp title={<>Leadership Skills (Score: {aiReport.leadershipSkills.score}/100)</>} summaryScore={aiReport.leadershipSkills.score} traitsObj={aiReport.leadershipSkills.traits} colorHex="#1e40af" />}
              </div>
            )}

            {/* Mandatory Skills */}
            {aiReport.mandatorySkills?.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  marginBottom: "12px"
                }}>Mandatory Skills Assessment (Score: {aiReport.mandatorySkillsScore || 0}/100)</h3>
                <div style={{ display: "flex", gap: "20px", alignItems: "stretch", flexWrap: "wrap" }}>
                  {aiReport.mandatorySkills.map((skill, idx) => (
                    <GaugeChartComp key={idx} title={skill.skill || skill.skillTopic} summaryScore={skill.score} traitsObj={{}} colorHex="#0369a1" />
                  ))}
                </div>
              </div>
            )}

            {/* Optional Skills */}
            {aiReport.optionalSkills?.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  marginBottom: "12px"
                }}>Optional Skills Assessment (Score: {aiReport.optionalSkillsScore || 0}/100)</h3>
                <div style={{ display: "flex", gap: "20px", alignItems: "stretch", flexWrap: "wrap" }}>
                  {aiReport.optionalSkills.map((skill, idx) => (
                    <GaugeChartComp key={idx} title={skill.skill || skill.skillTopic} summaryScore={skill.score} traitsObj={{}} colorHex="#8b5cf6" />
                  ))}
                </div>
              </div>
            )}

            {/* Conclusion */}
            {aiReport.conclusion && (
              <div style={{ marginBottom: "24px" }}>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  marginBottom: "12px"
                }}>AI Conclusion</h3>
                <div style={{
                  background: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
                  padding: "20px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0"
                }}>
                  <p style={{
                    fontSize: "16px",
                    lineHeight: "1.7",
                    color: "#334155",
                    margin: 0
                  }}>
                    {aiReport.conclusion}
                  </p>
                </div>
              </div>
            )}

            {/* Interview Questions & Answers */}
            {aiReport.questions?.length > 0 && (
              <div style={{ marginBottom: "24px" }}>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#1e293b",
                  marginBottom: "12px"
                }}>Interview Q&A Analysis</h3>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {aiReport.questions.map((qa, idx) => (
                    <div key={idx} style={{
                      background: "white",
                      border: "1px solid #e2e8f0",
                      borderRadius: "12px",
                      padding: "20px",
                      position: "relative"
                    }}>
                      {/* Accuracy Badge */}
                      <div style={{
                        position: "absolute",
                        top: "16px",
                        right: "16px",
                        background: qa.accuracyPercent >= 70 ? "#dcfce7" : qa.accuracyPercent >= 40 ? "#fef3c7" : "#fee2e2",
                        color: qa.accuracyPercent >= 70 ? "#166534" : qa.accuracyPercent >= 40 ? "#92400e" : "#991b1b",
                        padding: "6px 14px",
                        borderRadius: "20px",
                        fontSize: "14px",
                        fontWeight: "600"
                      }}>
                        {qa.accuracyPercent}% Accurate
                      </div>

                      {/* Question */}
                      <div style={{ marginBottom: "12px", paddingRight: "100px" }}>
                        <div style={{ fontSize: "14px", color: "#64748b", marginBottom: "4px", fontWeight: "600" }}>QUESTION {idx + 1}</div>
                        <div style={{ fontSize: "16px", color: "#1e293b", fontWeight: "500", lineHeight: "1.6" }}>
                          {qa.question}
                        </div>
                      </div>

                      {/* Answer */}
                      <div style={{ marginBottom: "12px" }}>
                        <div style={{ fontSize: "14px", color: "#64748b", marginBottom: "4px", fontWeight: "600" }}>ANSWER</div>
                        <div style={{
                          fontSize: "16px",
                          color: "#475569",
                          lineHeight: "1.6",
                          background: "#f8fafc",
                          padding: "12px",
                          borderRadius: "8px",
                          maxHeight: "150px",
                          overflowY: "auto"
                        }}>
                          {qa.answer}
                        </div>
                      </div>

                      {/* Feedback */}
                      {qa.feedbacks?.length > 0 && (
                        <div>
                          <div style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", fontWeight: "600" }}>AI FEEDBACK</div>
                          <ul style={{ margin: 0, paddingLeft: "20px", fontSize: "16px", color: "#334155", lineHeight: "1.7" }}>
                            {qa.feedbacks.map((feedback, fIdx) => (
                              <li key={fIdx} style={{ marginBottom: "6px" }}>{feedback}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Additional Attachments */}
        {attachmentImages && attachmentImages.length > 0 && (
          <div style={{ marginBottom: "40px" }}>
            <h2 style={{
              fontSize: "28px",
              fontWeight: "600",
              color: "#3b71ca",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              margin: "0 0 20px 0"
            }}>
              <div style={{
                width: "4px",
                height: "30px",
                background: "linear-gradient(135deg, #3b71ca, #2563eb)",
                borderRadius: "2px"
              }}></div>
              Additional Attachments
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {attachmentImages.map((att, idx) => (
                <div key={idx} style={{
                  background: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "16px"
                }}>
                  <div style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", marginBottom: "10px" }}>
                    {att.name}
                  </div>
                  {att.isImage ? (
                    <img
                      src={att.dataUrl}
                      alt={att.name}
                      style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                    />
                  ) : (
                    <div style={{ fontSize: "14px", color: "#64748b" }}>{att.fileName}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Footer */}
        <div style={{
          background: "#f8fafc",
          padding: "20px 40px",
          borderTop: "1px solid #e2e8f0",
          textAlign: "center",
          color: "#64748b",
          fontSize: "16px"
        }}>
          <p style={{ margin: "0" }}>© 2024 PANLS.AI Pvt Ltd. All Rights Reserved.</p>
          <p style={{ marginTop: "4px", fontSize: "14px", margin: "4px 0 0 0" }}>
            Evaluation Report Generated on {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>

    </>
  );
}